<mat-icon [fontIcon]="icon()" class="icon"></mat-icon>
<h6 class="title">
  <ng-content>No data available.</ng-content>
</h6>
